export const ENDPOINTS = {
  announcementStream: '/api/v1-preview/stream/homegames/announcement',
  serviceStatusStream: '/api/v1-preview/stream/homegames/servicestatus',
  cancelTournament: '/api/v1-preview/homegames/club/tournament/cancel',
  cancelJoinClub: '/api/v1-preview/homegames/players/club/cancel',
  changePlayerStatus: '/api/v1-preview/homegames/players/status',
  club: '/api/v1-preview/homegames/club',
  clubs: '/api/v1-preview/homegames/clubs',
  clubCreateTable: '/api/v1-preview/homegames/club/table/create',
  clubsInfoFilter: '/api/v1-preview/homegames/clubs/info/filter',
  clubMembersOptions: '/api/v1-preview/homegames/club/members/options',
  clubMessageRequest: '/api/v1-preview/homegames/club/messages',
  clubOptions: '/api/v1-preview/homegames/clubs/options',
  clubRecentTournamentSummary: '/api/v1-preview/homegames/club/tournament/summaries',
  clubSeason: '/api/v1-preview/homegames/club/seasons',
  clubSeasonStats: '/api/v1-preview/homegames/club/seasons/stats',
  clubPassword: '/api/v1-preview/homegames/club/password',
  clubTableStructures: '/api/v1-preview/homegames/club/table/structures',
  clubTableCancel: '/api/v1-preview/homegames/club/table/cancel',
  clubTournamentResults: '/api/v1-preview/homegames/club/tournament/results',
  createClubTournament: '/api/v1-preview/homegames/club/tournament/create',
  emailsFlag: '/api/v1-preview/homegames/club/options/emails/ignore',
  encodedWebEndpoint: '/api/v1-preview/homegames/webendpoint/encode',
  getPlayerBasedOnStatus: '/api/v1-preview/homegames/players/status',
  leaveClub: '/api/v1-preview/homegames/players/club/leave',
  lobby: '/api/v1-preview/homegames/lobby',
  resolveTags: 'tags.resolve',
  scheduledRingGames: '/api/v1-preview/homegames/scheduled/ringgames',
  scheduledTournaments: '/api/v1-preview/homegames/scheduled/tournaments',
  tournamentStructures: '/api/v1-preview/homegames/club/tournament/structures',
  wallStream: '/api/v1-preview/stream/homegames/wall',
  publicClubs: '/api/v1-preview/homegames/clubs/find',
  clubSeasonsRanks: '/api/v1-preview/homegames/seasons/ranks'
};

export default ENDPOINTS;
